import React from 'react';
import { PageShell } from '../components/layout/PageShell';
import './Welcome.css';

const Welcome: React.FC = () => {
  return (
    <PageShell className="welcome-landing-shell">
      <div className="welcome-landing" data-testid="welcome-landing-page">
        <div className="welcome-landing-card ev-animate-in">
          <div className="welcome-landing-header">
            <h1 className="welcome-landing-title">
              <span className="welcome-landing-title-text">Welcome</span>
            </h1>
          </div>

        <p className="welcome-landing-message">
            to get started scan your <br /> My Crypto Card
        </p>

          <div className="welcome-landing-qr-wrap">
            <img
              src="/welcome-card-qr-mock.svg"
              alt="Scan your My Crypto Card"
              className="welcome-landing-qr"
            />
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default Welcome;
